import { NewsPostType, PostType } from 'src/hook/usePosts'
import { HyperlinkCard, LiveCard } from 'src/components'
import { useVideoEmbed } from 'src/hook/useVideoEmbed'
import { FeedCardImage } from '../feedCardImage'
import { FeedCardVideo } from '../feedCardVideo'
import { FeedCardExternalVideo } from '../feedCardExternalVideo'
import { FeedCardMediaProps } from './feedCardMedia.types'

const FeedCardMedia = ({ post }: FeedCardMediaProps) => {
  const { youTube } = useVideoEmbed()

  const isYouTubeURL = youTube.isValidURL(post?.description)

  switch (post.postType) {
    case PostType.IMAGE:
      return <FeedCardImage post={post} />

    case PostType.URL:
      return isYouTubeURL ? <FeedCardExternalVideo post={post} /> : <HyperlinkCard post={post} />

    case PostType.VIDEO:
      return <FeedCardVideo post={post} />

    case NewsPostType.LIVE:
      return <LiveCard post={post} />

    default:
      return null
  }
}

export default FeedCardMedia
